import request from "@/uilt/new-axios.js";
import serverConfig from "@/assets/global/serverConfig";

export const updateSecondAssignApproveState = (params) => {
  return request.postJson(
    `/${serverConfig.msSalesPerformService}/downstream/statement/update-second_assign/approve_state`,
    params
  );
};

export const getAssignersIndex = (params) => {
  return request.postJson(
    `/${serverConfig.msSalesPerformService}/work-flow/data/get-assigners-index`,
    params
  );
};

export const computeScore = (params) => {
  return request.get(
    `/${serverConfig.msSalesPerformService}/downstream/statement/compute-score`,
    params
  );
};

export const getScore = (params) => {
  return request.get(
    `/${serverConfig.msSalesPerformService}/downstream/statement/get-score`,
    params
  );
};

export const getSurveyDetail = (params) => {
  return request.get(`/${serverConfig.msSalesPerformService}/survey/tenant/detail`, params);
};

export const getSurveyChangeNew = (params) => {
  return request.get(`/${serverConfig.msSalesPerformService}/survey/tenant/change/get-survey-change-new`, params);
};

export const submitApproveFirst = (submitApproveFirstFormData) => {
  return request.postJson(
    `/${serverConfig.msSalesPerformService}/downstream/payment/submit-approve-first`,
    submitApproveFirstFormData
  );
};

export const getUpdateServicePage = (data) => {
  return request.postJson(
    `/${serverConfig.msSalesPerformService}/task-edit/service/page-update-service`,
    data
  );
};

export const deleteTaskSalary = (data) => {
  return request.postJson(
    `/${serverConfig.msSalesPerformService}/staff-salary-task/data/delete-task-salary`,
    data
  );
};
